export default {
    title: '鹊桥',
    route: {
        index: '首页',
        network: '网关管理',
        interfaceGroup: '接口组管理',
        interfaceLog: '接口日志',
        apiProject: '项目管理',
        apiDocument: '项目接口',
        apiSource: '项目文档',
        apiPublicEnv: '测试环境',
        apiSourceDetail: '项目文档编辑',
        apiDocumentEdit: '项目接口编辑',
        apiPublicEnvDetail: '测试环境详情',
        interface: '网关接口',
        router: '网关路由',
        server: '网关服务端',
        security: '网关安全策略'
    }
};